import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import useUser from "../../../../core/hooks/use-user";

const ListarInvolucrados = ({ modalState }) => {
    const { involucrados } = modalState.data;

    const { getAccessToken } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "personas-involucradas-software",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        destroy: true,
        dom: "Bfrtip",
        id: "tableInvolucrados",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/involucrados/${involucrados.id}`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: () => {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de involucrados"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombreSoftware" },
            { data: "nombreDesarrollador" },
            { data: "nombreSupervisor" },
        ],
    };

    return (
        <Modal
            isOpen={modalState.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                {modalState.title}
            </ModalHeader>
            <ModalBody>
                <Datatable options={dtOptions}>
                    <table
                        className="w-100 table table-hover"
                        id="tableInvolucrados"
                    >
                        <thead className="bg-dark">
                            <tr>
                                <th className="text-center text-white">Id</th>
                                <th className="text-center text-white">Software</th>
                                <th className="text-center text-white">Desarrollador</th>
                                <th className="text-center text-white">Supervisor</th>
                            </tr>
                        </thead>
                    </table>
                </Datatable>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        key="close"
                        color="secondary"
                        onClick={() => {
                            modalState.close();
                        }}
                    >
                        <i className="fas fa-trash mr-2"></i>
                        Cancelar
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

ListarInvolucrados.propTypes = {
    modalState: PropTypes.object
}

export default ListarInvolucrados;
